// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonToggle = 'Rectangle';
var ButtonToggleGroup = 'Rectangle';
var ButtonDefault = 'Rectangle';
var IconButtonDefault = 'Rectangle';
var ShapeSemanticsAll = {
  ButtonDefault: ButtonDefault,
  ButtonToggle: ButtonToggle,
  ButtonToggleGroup: ButtonToggleGroup,
  IconButtonDefault: IconButtonDefault
};

export { ButtonDefault, ButtonToggle, ButtonToggleGroup, IconButtonDefault, ShapeSemanticsAll, ShapeSemanticsAll as default };
